import { sendEmail } from 'utils/sendEmail';

export const handleSendEmail = (
  title: string,
  subheading: string,
  articleUrl: string,
  to: string = ''
): string => {
  const subject = `${title} | Little Emperors `;
  const bodyLines = [
    'I thought you might be interested in this article from the Little Emperors Travel Journal:',
    title,
    subheading,
    '',
    `Read more here: ${articleUrl}`,
  ];
  const body = bodyLines.join('\n');

  return sendEmail({
    to,
    subject,
    body,
  });
};
